module.exports = __webpack_public_path__ + "img/desktop-neck-4_338x18.37dff618.png";